var Form = function(form) {

	var comp = $('[data-component="form"]');
	var $self = form;

	this.init = function() {

		customValidate();

		$($self).validate({
			ignore: '.ignore',
			errorPlacement: function() {
			 	return true;
			},
			rules: {
				nome: {
					required: true
				},
				mail: {
					required: true,
					email: true
				},
				phone: {
					required: true
				},
				message: {
					required: true
				},
				document: {
					required: true
				},
				maturity: {
					required: true
				},
				hiddenRecaptcha: {
	                required: function () {
	                    if (grecaptcha.getResponse() == '') {
	                        return true;
	                    } else {
	                        return false;
	                    }
	                }
            	}
			},
			submitHandler: function(form) {

				if($(form).valid()) {

					if($(form).attr('id') == 'complaint') {

						$(form).find("button").attr("disabled", true);

						var ContactComponent = $($self).data("id");
						var ContactData = {
							"Name": $($self).find("input[name='nome']").val(),
							"Email": $($self).find("input[name='mail']").val(),
							"Telephone": $($self).find("input[name='phone']").val(),
							"Message": $($self).find("textarea[name='message']").val()
						}

						//Exibir uma loading gif?

				        $.ajax({
				            type: "POST",
				            url: "/umbraco/surface/ContactUs/Send",
				            data: JSON.stringify({ "ContactData": ContactData, "ContactComponent": ContactComponent, "response": grecaptcha.getResponse() }),
				            dataType: "json",
				            async: true,
				            contentType: "application/json; charset=utf-8",
				            success: function (response) {

				                //resetar os campos ou apresentar mensagem de sucesso ou fazer animacao de formulario enviado
				                //esconder a loading gif
								$('[data-component="modal-form"] .text').text('Mensagem enviada!');
								$(form).find('a.hidden')[0].click();
								$(form).trigger("reset");
								grecaptcha.reset();
								$(form).find("button").attr("disabled", false);

				            },
				            error: function (e) {

				            	//se for necessário: exibir uma mensagem de erro personalizada
				            	//esconder a loading gif
				            	$('[data-component="modal-form"] .text').text('Erro ao enviar a mensagem!');
								$(form).find('a.hidden')[0].click();
								$(form).find("button").attr("disabled", false);
				            }
				        });
					}
				}
			}
		});

	}

	function customValidate() {

		var options = {
			onKeyPress: function (cpf, ev, el, op) {
				var masks = ['000.000.000-000', '00.000.000/0000-00'],
						mask = (cpf.length > 14) ? masks[1] : masks[0];
				el.mask(mask, op);
			}
		};

		$('.document').mask('000.000.000-000', options);

		 $.validator.addMethod("cpf", function(value, element) {
	        value = $.trim(value);

	        value = value.replace('.','');
	        value = value.replace('.','');
	        cpf = value.replace('-','');
	        while(cpf.length < 11) cpf = "0"+ cpf;
	        var expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
	        var a = [];
	        var b = new Number;
	        var c = 11;
	        for (i=0; i<11; i++){
	            a[i] = cpf.charAt(i);
	            if (i < 9) b += (a[i] * --c);
	        }
	        if ((x = b % 11) < 2) { a[9] = 0 } else { a[9] = 11-x }
	        b = 0;
	        c = 11;
	        for (y=0; y<10; y++) b += (a[y] * c--);
	        if ((x = b % 11) < 2) { a[10] = 0; } else { a[10] = 11-x; }

	        var retorno = true;
	        if ((cpf.charAt(9) != a[9]) || (cpf.charAt(10) != a[10]) || cpf.match(expReg)) retorno = false;

	        return this.optional(element) || retorno;

	    });
	}

	return this.init();

}
